const { fetchJSON } = window.BAO.Utils

class StoreSwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })

    this.countryParam = params.country

    if (this.countryParam !== null) {
      this.setStorageFromURL(this.countryParam)
    }
    /* ?country= in URL check - End */

    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySwitcher(countryCode)
      this.updateTrigger(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = window.localStorage.getItem(this.userLocationName)

      this.setupCountrySwitcher(countryCode)
      this.updateTrigger(countryCode)
    } else {
      fetchJSON('/browsing_context_suggestions.json', {
        method: 'GET',
      }).then((res) => {
        const countryCode = res.detected_values.country.handle

        this.setupCountrySwitcher(countryCode)
        this.updateTrigger(countryCode)
      })
    }
  }

  forceRedirect () {
    fetchJSON('/browsing_context_suggestions.json', {
      method: 'GET',
    }).then((res) => {
      const userCountry = res.detected_values.country.handle

      let windowPathname = window.location.pathname

      const subdomainFolder = windowPathname.split('/').filter((item) => {
        return item.indexOf('en-') > -1
      })

      if (subdomainFolder.length) {
        windowPathname = windowPathname
          .replace(subdomainFolder, '')
          .replace('//', '/')
      }

      window.location.href = `${
        this.selectedSites[this.countries[userCountry].site].url
      }${windowPathname}?country=${userCountry}`
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onLinkClick = this.onLinkClick.bind(this)
    this.onConfirmClick = this.onConfirmClick.bind(this)
    this.onDrawerLinkClick = this.onDrawerLinkClick.bind(this)
    this.onDrawerConfirmClick = this.onDrawerConfirmClick.bind(this)

    document.addEventListener('click', this.onLinkClick)
    document.addEventListener('click', this.onDrawerLinkClick)

    if (this.els?.confirm?.exists) {
      this.els.confirm.elements.forEach((confirmEl) => {
        this.listeners.add(confirmEl, 'click', this.onConfirmClick)
      })
    }

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.onCloseClick.bind(this))
      })
    }

    const modal = this.querySelector('[data-id="store-switcher"]')

    if (modal) {
      this.listeners.add(modal, 'cancel', (e) => {
        e.preventDefault()
        this.onCloseClick()
      })
    }

    if (this.externalEls?.confirm?.exists) {
      this.externalEls.confirm.elements.forEach((confirmEl) => {
        this.listeners.add(confirmEl, 'click', this.onDrawerConfirmClick)
      })
    }
  }

  setStorageFromURL (countryCode) {
    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }
  }

  onConfirmClick (event) {
    event.preventDefault()

    const currentLink = document.querySelector(
      `${this.els?.link?.selector}[aria-current="true"]`,
    )

    if (!currentLink) return

    const locale = this.selectedLocale ?? 'en'
    const countryCode = currentLink.dataset.countryCode.toLowerCase()
    const fullLocale = `${locale}-${countryCode}`
    const localePath = `/${fullLocale}`

    const base = `${currentLink.dataset.siteUrl}${localePath}${this.currentPageUrl}`
    const url = new URL(base)
    url.searchParams.set('country', currentLink.dataset.countryCode)
    const href = url.toString()

    if (window.location.href === href) {
      window.location.reload()
    } else {
      window.location.href = href
    }
  }

  onCloseClick () {
    const fallbackCountry = this.dataset.fallbackCountry

    if (fallbackCountry) {
      window.localStorage.setItem(this.userLocationName, fallbackCountry)
    }

    const modal = this.querySelector('[data-id="store-switcher"]')

    modal?.close()
    modal?.setAttribute('inert', '')

    document.body.classList.remove('util-SiteOverflowed')
  }

  onDrawerConfirmClick () {
    const currentLink = document.querySelector(
      `${this.externalEls?.link?.selector}[aria-current="true"]`,
    )

    if (!currentLink) return

    const locale = this.selectedLocale ?? 'en'
    const countryCode = currentLink.dataset.countryCode.toLowerCase()
    const fullLocale = `${locale}-${countryCode}`
    const localePath = `/${fullLocale}`

    const base = `${currentLink.dataset.siteUrl}${localePath}${this.currentPageUrl}`
    const url = new URL(base)
    url.searchParams.set('country', currentLink.dataset.countryCode)
    const href = url.toString()

    if (window.location.href === href) {
      window.location.reload()
    } else {
      window.location.href = href
    }
  }

  onLinkClick (event) {
    const linkSelector = this.els?.link?.selector

    if (!event.target.closest(linkSelector)) return

    const clickedLink = event.target.closest(linkSelector)

    if (clickedLink.dataset.externalUrl) {
      return
    }

    event.preventDefault()

    const allLinks = document.querySelectorAll(linkSelector)

    allLinks.forEach((link) => {
      link.removeAttribute('aria-current')
    })

    clickedLink.setAttribute('aria-current', 'true')

    const countryCode = clickedLink.dataset.countryCode

    const languages = this.countries[countryCode]?.languages ?? [
      {
        name: 'English',
        locale: 'en',
      },
    ]

    this.renderLanguagePicker(countryCode, languages, 'mod', null)
  }

  onDrawerLinkClick (event) {
    const linkSelector = this.externalEls?.link?.selector

    if (!event.target.closest(linkSelector)) return

    const clickedLink = event.target.closest(linkSelector)

    if (clickedLink.dataset.externalUrl) {
      return
    }

    event.preventDefault()

    const allLinks = document.querySelectorAll(linkSelector)

    allLinks.forEach((link) => {
      link.removeAttribute('aria-current')
    })

    clickedLink.setAttribute('aria-current', 'true')

    const countryCode = clickedLink.dataset.countryCode

    const languages = this.countries[countryCode]?.languages ?? [
      {
        name: 'English',
        locale: 'en',
      },
    ]

    this.renderLanguagePicker(countryCode, languages, 'drw', null)
    this.renderCurrentCountryLabel(countryCode)

    if (this?.externalEls?.['drawer-inner']?.exists) {
      const drawer = this.externalEls['drawer-inner'].element
      drawer.scrollTo({ top: drawer.scrollHeight, behavior: 'smooth' })
    }
  }

  renderCurrentCountryLabel (countryCode) {
    const container = this.externalEls.text.element

    container.innerHTML = ''

    const country = this.countries[countryCode.toUpperCase()]

    if (!country) return

    container.innerHTML = `${country.name} (${country.currency})`
  }

  renderLanguagePicker (countryCode, languages, prefix, activeLocale = null) {
    const container =
      prefix === 'mod'
        ? this.els.language.element
        : this.externalEls.language.element

    const confirmEl =
      prefix === 'mod'
        ? this.els.confirm.element
        : this.externalEls.confirm.element

    container.innerHTML = ''

    const resolvedLocale = activeLocale ?? languages[0].locale

    this.selectedLocale = resolvedLocale

    confirmEl.disabled = false

    const label = document.createElement('p')

    label.className = `${prefix}-StoreSwitcher_LanguageTitle fz-20_130`
    label.textContent = this.dataset.selectLanguageText

    const picker = document.createElement('ul')

    picker.className = `${prefix}-StoreSwitcher_LanguageItems`

    languages.forEach(({ name, locale }) => {
      const isActive = locale === resolvedLocale

      const li = document.createElement('li')

      li.className = `${prefix}-StoreSwitcher_LanguageItem`

      li.innerHTML = `
        <button
          type="button"
          class="${prefix}-StoreSwitcher_LanguageButton fz-14_140"
          data-locale="${locale}"
          ${isActive ? 'aria-current="true"' : ''}
        >
          ${name}
        </button>
      `

      li.querySelector('button').addEventListener('click', (event) => {
        picker
          .querySelectorAll('button')
          .forEach((button) => button.removeAttribute('aria-current'))

        event.currentTarget.setAttribute('aria-current', 'true')

        this.selectedLocale = locale

        confirmEl.disabled = false
      })

      picker.appendChild(li)
    })

    container.appendChild(label)
    container.appendChild(picker)
  }

  updateTrigger (countryCode, locale = null) {
    const upperCountryCode = countryCode.toUpperCase()

    if (this.countries[upperCountryCode] === undefined) return

    const resolvedLocale = locale ?? window.Shopify?.locale ?? 'en'

    if (this.externalEls?.['trigger-text']?.exists) {
      this.externalEls['trigger-text'].elements.forEach((el) => {
        el.innerHTML = `${upperCountryCode} / ${resolvedLocale.toUpperCase()}`
      })
    }

    if (this.externalEls?.['trigger-flag']?.exists) {
      this.externalEls['trigger-flag'].elements.forEach((el) => {
        el.innerHTML = `
          <img
            src="https://cdn.shopify.com/static/images/flags/${countryCode.toLowerCase()}.svg"
            width="30"
            height="30"
            alt="${upperCountryCode}"
          />
        `
      })
    }
  }

  setupCountrySwitcher (countryCode) {
    this.createOptions(countryCode)

    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }

    const upperCode = countryCode.toUpperCase()

    const languages = this.countries[upperCode]?.languages ?? [
      {
        name: 'English',
        locale: 'en',
      },
    ]

    const currentLocale = window.Shopify?.locale ?? 'en'

    this.selectedLocale = currentLocale

    this.renderCurrentCountryLabel(upperCode)

    this.renderLanguagePicker(upperCode, languages, 'mod', currentLocale)

    this.renderLanguagePicker(upperCode, languages, 'drw', currentLocale)

    this.updateTrigger(upperCode, currentLocale)

    if (!this.noLocationStored) return
    if (this.countryParam !== null) return

    const modal = this.querySelector('[data-id="store-switcher"]')

    modal?.removeAttribute('inert')
    modal?.showModal()

    document.body.classList.add('util-SiteOverflowed')
  }

  createOptions (countryCode) {
    const grouped = Object.entries(this.countries).reduce(
      (acc, [key, value]) => {
        const group = value.group || 'Other'

        if (!acc[group]) {
          acc[group] = []
        }

        acc[group].push([key, value])

        return acc
      },
      {},
    )

    const groupOrder = ['North America', 'Europe', 'Asia']

    const sortedGroups = [
      ...groupOrder.filter((group) => grouped[group]),
      ...Object.keys(grouped).filter((group) => !groupOrder.includes(group)),
    ]

    let modalHTML = ''
    let drawerHTML = ''

    sortedGroups.forEach((groupName) => {
      const countries = grouped[groupName]

      const groupId = groupName.toLowerCase().replace(/\s+/g, '-')

      const modalItems = countries
        .map(([key, value]) => {
          const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()

          return this.createModalElement(
            key,
            value.site,
            isCurrentSite,
            value.name,
          )
        })
        .join('')

      const drawerItems = countries
        .map(([key, value]) => {
          const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()

          return this.createDrawerElement(
            key,
            value.site,
            isCurrentSite,
            value.name,
          )
        })
        .join('')

      modalHTML += this.createAccordionGroup(
        groupName,
        groupId,
        modalItems,
        'mod',
      )

      drawerHTML += this.createAccordionGroup(
        groupName,
        groupId,
        drawerItems,
        'drw',
      )
    })

    this.els.options.element.innerHTML = modalHTML
    this.externalEls.options.element.innerHTML = drawerHTML
  }

  createAccordionGroup (groupName, groupId, itemsHTML, prefix) {
    const panelId = `store-switcher-${prefix}-${groupId}`

    return `
      <accordion-group class="${prefix}-StoreSwitcher_Accordion">
        <button
          type="button"
          class="${prefix}-StoreSwitcher_AccordionTitle fz-16_140"
          aria-controls="${panelId}"
          aria-expanded="false"
          data-accordion-group-el="trigger"
        >
          ${groupName}

          <div class="${prefix}-StoreSwitcher_AccordionIcons">
            <div class="${prefix}-StoreSwitcher_AccordionIcon ${prefix}-StoreSwitcher_AccordionIcon-plus">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="currentColor" d="M13 11h5v2h-5v5h-2v-5H6v-2h5V6h2z"/>
              </svg>
            </div>

            <div class="${prefix}-StoreSwitcher_AccordionIcon ${prefix}-StoreSwitcher_AccordionIcon-minus">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="currentColor" d="M18 13H6v-2h12z"/>
              </svg>
            </div>
          </div>
        </button>

        <div
          class="${prefix}-StoreSwitcher_AccordionBody"
          aria-hidden="true"
          id="${panelId}"
          data-accordion-group-el="content"
        >
          <div class="${prefix}-StoreSwitcher_AccordionContent">
            <div class="${prefix}-StoreSwitcher_AccordionItems">
              ${itemsHTML}
            </div>
          </div>
        </div>
      </accordion-group>
    `
  }

  createModalElement (code, site, isCurrentSite, country) {
    const countryConfig = this.countries[code]
    const siteUrl = countryConfig?.externalUrl ?? this.selectedSites[site]?.url

    if (!siteUrl) return ''

    const flagCode = code.toLowerCase()
    const isExternal = Boolean(countryConfig?.externalUrl)

    return `
    <div class="mod-StoreSwitcher_AccordionItem">
      <a
        class="mod-StoreSwitcher_AccordionLink fz-14_140"
        href="${isExternal ? siteUrl : `${siteUrl}${this.dataset.pageUrl}?country=${code}`}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
        data-store-switcher-el="link"
        data-country-code="${code}"
        data-site-url="${siteUrl}"
        ${isExternal ? `data-external-url="${siteUrl}"` : ''}
      >
        <img
          class="mod-StoreSwitcher_AccordionFlag"
          src="https://cdn.shopify.com/static/images/flags/${flagCode}.svg"
          width="16"
          height="16"
          alt=""
          aria-hidden="true"
        />

        <span class="mod-StoreSwitcher_LinkName">
          ${country}
        </span>
      </a>
    </div>
  `
  }

  createDrawerElement (code, site, isCurrentSite, country) {
    const countryConfig = this.countries[code]
    const siteUrl = countryConfig?.externalUrl ?? this.selectedSites[site]?.url

    if (!siteUrl) return ''

    const flagCode = code.toLowerCase()
    const isExternal = Boolean(countryConfig?.externalUrl)

    return `
    <div class="drw-StoreSwitcher_AccordionItem">
      <a
        class="drw-StoreSwitcher_AccordionLink fz-14_140"
        href="${isExternal ? siteUrl : `${siteUrl}${this.dataset.pageUrl}?country=${code}`}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
        data-store-switcher-external-el="link"
        data-country-code="${code}"
        data-site-url="${siteUrl}"
        ${isExternal ? `data-external-url="${siteUrl}"` : ''}
      >
        <img
          class="drw-StoreSwitcher_AccordionFlag"
          src="https://cdn.shopify.com/static/images/flags/${flagCode}.svg"
          width="16"
          height="16"
          alt=""
          aria-hidden="true"
        />

        <span class="drw-StoreSwitcher_LinkName">
          ${country}
        </span>
      </a>
    </div>
  `
  }

  get currentPageUrl () {
    const path = window.location.pathname.replace(
      /^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/,
      '',
    )

    const params = new URLSearchParams(window.location.search)
    params.delete('country')

    const qs = params.toString()

    return qs ? `${path}?${qs}` : path
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !window.Shopify.designMode)
    )
  }

  get userLocationName () {
    return 'BAO-localization'
  }

  get selectedSites () {
    return this.sites
  }

  get sites () {
    return {
      EU: {
        url: 'https://burton-eu-production.myshopify.com',
      },
      JP: {
        url: 'https://burton-jp-production.myshopify.com',
      },
      NA: {
        url: 'https://burton-na-production.myshopify.com',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-switcher')) {
  customElements.define('store-switcher', StoreSwitcher)
}
